import { Box } from "@mui/material";
import imgFrancois from "../../../../ressources/images/francois-xavier-leoni.jpg";
import points from "../../../../ressources/images/points.png";
import styles from "./styles";

function BlocQuiSommesNous() {
  const onClickEvent = () => {
    if (window.MatomoTagManager) {
      window._paq.push([
        "trackEvent",
        "Site Bessé",
        "Clic - CTA",
        "Accueil - En savoir plus site Bessé",
      ]);
    }
  };

  return (
    <Box className={"container"} sx={styles}>
      <div className={"texte"}>
        <h3>Qui sommes nous</h3>
        <h4>
          <span className={"besse"}>Bessé</span> Immobilier & Construction
          <br />
          <span className={"subtitle"}>Conseil en assurances</span>
        </h4>
        <div className={"divider"} />
        <p>
          <strong>Bessé Immobilier & Construction</strong> est l'un des leaders
          du courtage en assurances dans le secteur de l'immobilier. Au-delà de
          l'expertise du conseil en assurances proposé aux professionnels
          (gestionnaires locatifs, syndics de copropriété), notre volonté est de
          vous offrir des solutions ultra-spécialisées et novatrices, en réponse
          à vos attentes.
          <br />
          Vous nous avez suggéré{" "}
          <span className="vertuloo-font-sm vert">vertuloo</span>, <br />
          nous l'avons développé pour vous.
        </p>
        <h5>
          François-Xavier LEONI <span>- Directeur</span>
        </h5>
        <a
          href="https://www.besse.fr/fr/vos-secteurs-dactivites/immobilier"
          target="_blank"
          rel="noopener noreferrer"
          className={"linkPlus linkPlusBleu"}
          onClick={onClickEvent}
        >
          en savoir plus
        </a>
      </div>
      <div className={"containerImage"}>
        <img src={points} className={"dots"} alt="immobilier" width={70} />
        <img src={imgFrancois} width="300" alt="François-Xavier LEONI" />
        <div className={"rectangle"} />
      </div>
    </Box>
  );
}

export default BlocQuiSommesNous;
